import { Route, Routes } from "react-router-dom";
import { useState } from "react";
import {
  MantineProvider,
  ColorSchemeProvider,
  ColorScheme,
} from "@mantine/core";
import { NotificationsProvider } from "@mantine/notifications";
import routes from "./routes";
import ScrollToTop from "App/ScrollToTop";
import CategoryContextProvider from "features/forestage/Categories/CategoryContext";
import NotFound from 'features/forestage/Error';

export { default as store } from "./store";

const App = () => {
  const [colorScheme, setColorScheme] = useState<ColorScheme>("light");

  const toggleColorScheme = (value?: ColorScheme) =>
    setColorScheme(value || (colorScheme === "dark" ? "light" : "dark"));

  return (
    <ColorSchemeProvider
      colorScheme={colorScheme}
      toggleColorScheme={toggleColorScheme}
    >
      <MantineProvider
        theme={{
          colorScheme,
          fontFamily:
            "Helvetica, Arial, 'PingFang TC', '蘋方-繁', 'Noto Sans CJK TC', 'source-han-sans-traditional', 'Hiragino Sans', 'Droid Sans Fallback', 'Microsoft YaHei', '微軟正黑體','Microsoft JhengHei', sans-serif",
          fontFamilyMonospace: "Monaco, Courier, monospace",
          headings: { fontFamily: "Greycliff CF, sans-serif" },
        }}
        withGlobalStyles
        withNormalizeCSS
      >
        <NotificationsProvider>
          <ScrollToTop />

          <CategoryContextProvider>
            <Routes>
              {routes.map((route, index) => {
                const { Component, routes: partialRoutes, ...rest } = route;

                return partialRoutes ? (
                  <Route key={index} {...rest} element={<Component />}>
                    {partialRoutes.map((partialRoute, partialIndex) => {
                      const { Component: PartialComponent, ...partialRest } =
                        partialRoute;
                      return (
                        <Route
                          key={`${index}_${partialIndex}`}
                          {...partialRest}
                          element={<PartialComponent />}
                        />
                      );
                    })}
                  </Route>
                ) : (
                  <Route key={index} {...rest} element={<Component />} />
                );
              })}
            </Routes>
          </CategoryContextProvider>
        </NotificationsProvider>
      </MantineProvider>
    </ColorSchemeProvider>
  );
};

export default App;
